import React from 'react';

import { Typography } from '@mui/material';



export default function FightDogStates(props) {

    let breed = props.breed
    // if entry "prohibited" exists in breed, then it is prohibited


    if (breed === undefined || breed.prohibited === undefined) {
        return (
            <></>
        )
    }


    // if  breed.probibit is not a list
    //check if prohibited is an array
    if (!Array.isArray(breed.prohibited)) {

        let states = Array.prototype.concat(breed.prohibited.general, breed.prohibited.category_1, breed.prohibited.category_2)
        let states_string = states.join(", ").replace(/,(?=[^,]*$)/, ' und')

        return (
            <>
                <Typography variant="h2" gutterBottom>
                    In welchen Bundesländern ist der {breed.breed} verboten?
                </Typography>

                Die Haltung der Rasse "{breed.breed}" ist in den Bundesländern <b>{states_string}</b> nur <b>unter Auflagen</b> erlaubt.


                <Typography variant="body1" gutterBottom>
                    In Thüringen, Niedersachsen und Schleswig-Holstein gibt es generell keine Beschränkungen für die Haltung von Listenhunden.
                </Typography>
            </>
        )
    }

    return null
    

}
